export const REPORTE_BASE_OBJ = {
    anio: 0,
    evidencias: {},
    id_caso: '',
    id_paciente: '',
    id_propietario: '',
    id_sucursal: '',
    informacion: {
        concepto: '',
        dias: '',
        observaciones: '',
        presentacion: '',
        racion: '',
        tipo_servicio: '',
        unidadesMedida: ''
    },
    no_ticket: 0,
    receta: {},
    servicio_generico: {
        activo: true,
        cantidad: 0,
        cantidad2: 0,
        completado: false,
        concepto: '',
        concepto_vencimiento: '',
        descuento: {},
        descuento_personalizado: 0,
        descuento_personalizado_nombre: '',
        hora: '',
        info: {
            fecha_alta: '',
            fecha_vencimiento: ''
        },
        monedero: {
            aplica: false,
            cantidad: 0
        },
        monto: 0,
        nombre: '',
        pesos_monedero: 0,
        precio: '',
        responsable: {
            email: '',
            id: '',
            nombre: '',
            rol: ''
        },
        servicio: {
            SKU: '',
            activo: true,
            id: '',
            nombre: '',
            precioVenta: 0,
            presentacion: 0,
            unidadMedida: ''
        },
        servicio_padre: null,
        subtotal: '',
        total: 0,
        ticket: null,
        tipo: ''
    }
}

const BASE_SELECCIONAR = {
    id:null,
    seleccionado:false,
}

export const FILTROS1_REPORTES = {
    fecha:{
        del:{},
        al:{},
        anio:null,
        seleccionado:false,
    },
    propietario:{...BASE_SELECCIONAR},
    proveedor:{...BASE_SELECCIONAR},
    marca:{...BASE_SELECCIONAR},
    categoria:{
        seleccionado:false,
        categoria:null,
    },
    concepto:{
        seleccionado:false,
        concepto:null,
    },
    tipoServicio:{
        seleccionado:false,
        servicio:null,
    },
    linea:{...BASE_SELECCIONAR},
}

export const FILTROS2_REPORTES = {
    desde:null,
    paciente:{...BASE_SELECCIONAR},
    colaborador:{...BASE_SELECCIONAR},
    producto_servicio_estudio:{...BASE_SELECCIONAR},
    agrupar:null,
    equipo:{
        seleccionado:false,
        equipo:null,
    },
    sucursal:{...BASE_SELECCIONAR},
}

export const FILTROS3_REPORTES = {
    usuario:{...BASE_SELECCIONAR},
    metodo_pago:{...BASE_SELECCIONAR},
    categoria:null,
    mostrar:null,
    agrupar_por:null,
    pago_con_tarjeta:null,
    recoleccion:null,
    con_descuento:null,
    proveedor:null,
    estatus:null,
    imprimir_a:null,
    ticket:{
        del_folio:0,
        al_folio:0,
        seleccionado:false,
    }
}

export const FILTROS_REPORTE = {
    filtro1:{...FILTROS1_REPORTES},
    filtro2:{...FILTROS2_REPORTES},
    filtro3:{...FILTROS3_REPORTES},
    reporteSeleccionado:null,
}


// WEBPACK FOOTER //
// ./src/constantes/reportes/index.js